import { StringUtil, UserSettings } from "@mcleod/core";
import { AutogenLayoutServiceIncidentQuickInfo } from "./autogen/AutogenLayoutServiceIncidentQuickInfo";
import { Snackbar, TableRow, TableRowDisplayEvent } from "@mcleod/components";

export class ServiceIncidentQuickInfo extends AutogenLayoutServiceIncidentQuickInfo {

    detailButtonOnClick(event: MouseEvent) {
        const firstRow = this.tableServiceIncidents.rows[0];
        const orderId = firstRow?.data.get("order_id");
        const status = "A";
        if (!orderId) {
            Snackbar.showSnackbar("No Order ID available to navigate to Service Incident page.");
            return;
        }
        window.open(`/lme/dispatch/ServiceIncidentList?order_id=${orderId}&status=${status}`, '_blank');
    }

    labelStandardCodeOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const row = (event.target as TableRow).data;
        let desc = row.get("edi_standard_code.description");
        //if metadata issue, code UN for example is not valid standard code, but can be sent in through mobile comm, so would not have a description to display.
        if (desc == "" || desc == null || desc == undefined) {
            desc = row.get("edi_standard_code");
        }
        row.set("edi_standard_code.description", desc);

    }
}
